// Poligono de la geocerca de una ubicacion (DOLE tramos a puerto, diseno 3.3).
// En la base se guarda como WKT 'POLYGON((lon lat, ...))' (EPSG 4326); en el mapa, como [{ lat, lng }].
// El backend (GeocercaPoligono.java) vuelve a validar y normaliza al guardar.

export const wktAVertices = (wkt) => {
    if (!wkt || typeof wkt !== 'string') return [];
    const m = wkt.match(/^\s*POLYGON\s*\(\((.+)\)\)\s*$/i);
    if (!m) return [];
    const vertices = m[1].split(',')
        .map(par => par.trim().split(/\s+/).map(Number))
        .filter(xy => xy.length === 2 && xy.every(n => Number.isFinite(n)))
        .map(([lng, lat]) => ({ lat, lng }));
    // el anillo viene cerrado: el ultimo repite al primero
    if (vertices.length > 1) {
        const a = vertices[0], b = vertices[vertices.length - 1];
        if (a.lat === b.lat && a.lng === b.lng) vertices.pop();
    }
    return vertices;
};

export const verticesAWkt = (vertices) => {
    if (!vertices || vertices.length === 0) return null;
    const anillo = [...vertices, vertices[0]];
    return 'POLYGON((' + anillo.map(v => v.lng + ' ' + v.lat).join(', ') + '))';
};
